module.exports = __webpack_public_path__ + "img/popup_try.8ea11da7.png";